$(document).ready(function () {
    window.checkRangeBox = function() {
        var minValue = document.getElementById("min_price").value.trim();
        var maxValue = document.getElementById("max_price").value.trim();
        var minInput = minValue === '' ? null : parseFloat(minValue);
        var maxInput = maxValue === '' ? null : parseFloat(maxValue);

        if ((minInput === null && maxInput === null)
            || (minInput !== null && (isNaN(minInput) || minInput < 0))
            || (maxInput !== null && (isNaN(maxInput) || maxInput < 0))) {
            swal.fire({
                title: "Please enter a valid price!",
                icon: "warning",
            });
            return false;
        } else if (minInput !== null && maxInput !== null && minInput > maxInput) {
            swal.fire({
                title: "Lowest price should be less than highest price!",
                icon: "warning",
            });
            return false;
        } else {
            var form = document.getElementById("priceRangeForm");
            var actionUrl = new URL(form.action);
            var currentUrl = new URL(window.location.href);
            var url = currentUrl.pathname === actionUrl.pathname ? currentUrl : actionUrl;
            if (minInput === null) url.searchParams.delete('min_price');
            else url.searchParams.set('min_price', minInput);
            if (maxInput === null) url.searchParams.delete('max_price');
            else url.searchParams.set('max_price', maxInput);
            url.searchParams.delete('page');
            if (url.pathname === currentUrl.pathname) {
                url.hash = '#product-results';
            }
            window.location.assign(url.toString());
        }
    };
});


